import type { LogoName } from '@highlight/ui'

/** The brand mark for each integration, toolset or provider id the renderer knows by name. */
const PROVIDER_LOGO = new Map<string, LogoName>(
  Object.entries({
    slack: 'slack',
    linear: 'linear-dark',
    notion: 'notion',
    gmail: 'gmail',
    github: 'github',
    'google-calendar': 'google-calendar',
    google_calendar: 'google-calendar',
    'google-contacts': 'google',
    'google-directory': 'google',
    'microsoft-contacts': 'outlook',
    'microsoft-calendar': 'outlook',
    'microsoft-outlook': 'outlook',
    'outlook-calendar': 'outlook',
    outlook_calendar: 'outlook',
  } satisfies Record<string, LogoName>),
)

export const providerLogo = (id: string | undefined): LogoName | undefined =>
  id === undefined ? undefined : PROVIDER_LOGO.get(id)
